import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Input,
  Button,
  FormField,
  SpaceBetween,
  Form,
  Container,
  InputProps,
} from "@cloudscape-design/components-themed";
import { ClickDetail } from "@cloudscape-design/components-themed/internal/events";
import { Auth } from "aws-amplify";

import { COMMON_LABELS } from "../default-constants";
import { LABELS } from "./constants";
import { useAppSelector, useAppDispatch } from "../../app/hook";
import { forgetLocation } from "../../features/authentication/location-slice";
import { addNotification } from "../../features/error/notifications-slice";
import {
  createFormErrTxt,
  clearFormErrTxt,
} from "../../features/error/validation-slice";
import { useUpdateUserResendCodeMutation } from "../../features/api";

interface UserInput {
  emailVerifyCode: string;
}

const VerifyEmail = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [resendCode] = useUpdateUserResendCodeMutation();

  const { formErrTxt } = useAppSelector((state) => state.validation);

  //ユーザ入力
  const [input, setInput] = useState<UserInput>({
    emailVerifyCode: "",
  });

  // Input更新関数
  const handleInputOnChange = (name: keyof UserInput, value: string) => {
    setInput({ ...input, [name]: value });
  };

  /**
   * 検証関数
   */
  const handleOnSubmitClick = async () => {
    if (!input.emailVerifyCode) {
      dispatch(
        createFormErrTxt({
          msgId: "KGRERR023",
          msgArgs: ["検証コード"],
        })
      );
      return;
    }
    dispatch(clearFormErrTxt());
    await Auth.verifyCurrentUserAttributeSubmit("email", input.emailVerifyCode)
      .then(async () => {
        await Auth.signOut();
        dispatch(forgetLocation());
        navigate("/sign-in");
      })
      .catch(() => {
        dispatch(
          addNotification({
            msgId: "KGRERR041",
            msgArgs: [],
          })
        );
      });
  };

  /**
   * コード再送信ボタンクリック
   * @param event
   */
  const handleResendCodeBtnOnClick = async (e: CustomEvent<ClickDetail>) => {
    const user = await Auth.currentAuthenticatedUser();
    resendCode(user?.username);
  };

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <Form
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="primary" onClick={handleOnSubmitClick}>
              {COMMON_LABELS.BTNS.VERIFY}
            </Button>
          </SpaceBetween>
        }
        errorText={formErrTxt}
      >
        <Container>
          <SpaceBetween direction="vertical" size="xs">
            <FormField label={LABELS.CODE}>
              <Input
                name="emailVerifyCode"
                value={input.emailVerifyCode}
                onChange={({ detail }: { detail: InputProps.ChangeDetail }) =>
                  handleInputOnChange("emailVerifyCode", detail.value)
                }
                type="password"
              />
            </FormField>
            <Button variant="link" onClick={handleResendCodeBtnOnClick}>
              {LABELS.RESEND_CODE}
            </Button>
          </SpaceBetween>
        </Container>
      </Form>
    </form>
  );
};

export default VerifyEmail;
